/* istanbul ignore file */
import { useEffect, useState } from 'react';
import { InputData } from 'framework/list';
import { useShowContext } from 'framework/show';
import useExpertiseService from './expertiseService';

export const useExpertiseGetData = () => {
  const { findAllEmployeeExpertise } = useExpertiseService();
  const [data, setData] = useState<InputData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { data: employeeData } = useShowContext();
  const employeeId = employeeData?.alias || '';

  useEffect(() => {
    setIsLoading(true);
    findAllEmployeeExpertise().then(responseData => {
      if (responseData) {
        setData({ ...responseData, items: responseData.result });
      }
      setIsLoading(false);
    });
  }, [employeeId, findAllEmployeeExpertise]);

  return {
    currentData: data,
    isLoading,
  };
};
